import { Dialog, Typography } from '@shinetools/lumen-react'
import { useTranslation } from 'react-i18next'

interface ReconciliationViewBannerDismissDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export const ReconciliationViewBannerDismissDialog = ({
  isOpen,
  onClose,
  onConfirm,
}: ReconciliationViewBannerDismissDialogProps) => {
  const { t } = useTranslation()

  return (
    <Dialog
      body={<Typography.Text>{t('bank_transactions.reconciliation_view_banner.dismiss_dialog.body')}</Typography.Text>}
      open={isOpen}
      title={t('bank_transactions.reconciliation_view_banner.dismiss_dialog.title')}
      primaryAction={{
        label: t('bank_transactions.reconciliation_view_banner.dismiss_dialog.confirm'),
        onClick: onConfirm,
      }}
      secondaryAction={{
        label: t('bank_transactions.reconciliation_view_banner.dismiss_dialog.keep'),
        onClick: onClose,
      }}
      onClose={onClose}
    />
  )
}
